import React from 'react'

function ComparisonReport() {
  return (
    <div>
        <h1>ComparisonReport Page...</h1>
    </div>
  )
}

export default ComparisonReport